import 'flowbite';

Fancybox.bind("[data-fancybox]");

  jQuery(document).ready(function ($) {
    var date = $("#date_format");

    if(date.length){
      formatarData()
    }

    var $imageBg = $('[data-image-bg]');

    if (!$imageBg.length) return

    $imageBg.each(function () {

        var item = $(this);
        var image = $(item).data('image-bg');

        $(item).css({
            'backgroundImage': "url(" + image + ")"
        });
    });
});


function formatarData() {
  var dataOriginalInput = document.getElementById("date_format");
  var dataOriginal = dataOriginalInput.getAttribute("date");

  var partesData = dataOriginal.split('/');
  var dia = parseInt(partesData[0], 10);
  var mes = parseInt(partesData[1], 10);
  var ano = parseInt(partesData[2], 10);

  var dataObj = new Date(ano, mes - 1, dia); // Meses em JavaScript começam do zero

  var opcoes = { day: 'numeric', month: 'long', year: 'numeric' };

  var dataFormatada = dataObj.toLocaleDateString('pt-BR', opcoes);

  dataOriginalInput.innerHTML = dataFormatada;
}

// Chamando a função quando a página carregar

/**
 *  SWIPER
 */

var swiper_banner = new Swiper(".swiper_banner", {
  loop: true,
  autoplay: {
      delay: 4000,
      disableOnInteraction: false,
  },
});

var swiper_lancamento = new Swiper(".swiper_lancamento", {
    loop: true,
    spaceBetween: 10,
    autoplay: {
        delay: 4000,
        disableOnInteraction: false,
    },
    breakpoints: {
        600:{
            slidesPerView: 2,
            spaceBetween: 30,
        },
        728: {
          slidesPerView: 2,
          spaceBetween: 30,
        },
        992: {
          slidesPerView: 2,
          spaceBetween: 30,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 30,
        },
    },
    navigation: {
        nextEl: ".lancamento-button-next",
        prevEl: ".lancamento-button-prev",
      },
  });

  var swiper_cards = new Swiper(".swiper_cards", {
    loop: true,
    spaceBetween: 10,
    autoplay: {
        delay: 4000,
        disableOnInteraction: false,
    },
    breakpoints: {
        600:{
            slidesPerView: 2,
            spaceBetween: 30,
        },
        728: {
          slidesPerView: 2,
          spaceBetween: 30,
        },
        992: {
          slidesPerView: 2,
          spaceBetween: 30,
        },
        1299: {
            slidesPerView: 3,
            spaceBetween: 30,
          },
        1300: {
          slidesPerView: 4,
          spaceBetween: 30,
        },
    },
    /*navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },*/
  });

  var swiper_financeiro = new Swiper(".swiper_financeiro", {
    loop: true,
    spaceBetween: 10,
    autoplay: {
        delay: 4000,
        disableOnInteraction: false,
    },
    breakpoints: {
        300:{
            slidesPerView: 2,
            spaceBetween: 30,
        },
        728: {
          slidesPerView: 3,
          spaceBetween: 30,
        },
        992: {
          slidesPerView: 3,
          spaceBetween: 30,
        },
        1299: {
            slidesPerView: 3,
            spaceBetween: 30,
          },
        1300: {
          slidesPerView: 4,
          spaceBetween: 30,
        },
    },
    /*navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      */
  });

  var swiper_noticias = new Swiper(".swiper_noticias", {
    loop: true,
    spaceBetween: 10,
    autoplay: {
        delay: 4000,
        disableOnInteraction: false,
    },
    breakpoints: {
        530:{
            slidesPerView: 2,
            spaceBetween: 30,
        },
        728: {
          slidesPerView: 2,
          spaceBetween: 30,
        },
        992: {
          slidesPerView: 3,
          spaceBetween: 30,
        },
        1299: {
            slidesPerView: 3,
            spaceBetween: 30,
          },
        1300: {
          slidesPerView: 4,
          spaceBetween: 30,
        },
    },
    navigation: {
        nextEl: ".noticia-button-next",
        prevEl: ".noticia-button-prev",
      },
  });


  var swiper_sociais = new Swiper(".swiper_sociais", {
    loop: true,
    spaceBetween: 10,
    autoplay: {
        delay: 4000,
        disableOnInteraction: false,
    },
    breakpoints: {
        425:{
            slidesPerView: 1,
            spaceBetween: 30,
        },
        503: {
          slidesPerView: 2,
          spaceBetween: 30,
        },
        992: {
          slidesPerView: 3,
          spaceBetween: 30,
        },
        1299: {
            slidesPerView: 3,
            spaceBetween: 30,
          },
        1300: {
          slidesPerView: 4,
          spaceBetween: 30,
        },
    },
    /*navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      */
  });


  var swiper_sociais = new Swiper(".swiper_sociais", {
    loop: true,
    spaceBetween: 10,
    autoplay: {
        delay: 4000,
        disableOnInteraction: false,
    },
    breakpoints: {
        425:{
            slidesPerView: 1,
            spaceBetween: 30,
        },
        503: {
          slidesPerView: 2,
          spaceBetween: 30,
        },
        992: {
          slidesPerView: 3,
          spaceBetween: 30,
        },
        1299: {
            slidesPerView: 3,
            spaceBetween: 30,
          },
        1300: {
          slidesPerView: 4,
          spaceBetween: 30,
        },
    },
    /*navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      */
  });


  var swiper_gallery = new Swiper(".swiper_gallery", {
    loop: true,
    spaceBetween: 10,
    autoplay: {
        delay: 4000,
        disableOnInteraction: false,
    },
    breakpoints: {
        425:{
            slidesPerView: 1,
            spaceBetween: 30,
        },
        503: {
          slidesPerView: 2,
          spaceBetween: 30,
        },
        992: {
          slidesPerView: 3,
          spaceBetween: 30,
        },
        1299: {
            slidesPerView: 3,
            spaceBetween: 30,
          },
    },
    navigation: {
        nextEl: ".gallery-single-button-next",
        prevEl: ".gallery-single-button-prev",
      },
  });

  var swiper_gallery_videos = new Swiper(".swiper_gallery-videos", {
    loop: true,
    spaceBetween: 10,
    autoplay: {
        delay: 4000,
        disableOnInteraction: false,
    },
    breakpoints: {
        425:{
            slidesPerView: 1,
            spaceBetween: 30,
        },
        503: {
          slidesPerView: 2,
          spaceBetween: 30,
        },
        992: {
          slidesPerView: 3,
          spaceBetween: 30,
        },
        1299: {
            slidesPerView: 3,
            spaceBetween: 30,
          },
    },
    navigation: {
        nextEl: ".gallery-videos-button-next",
        prevEl: ".gallery-videos-button-prev",
      },
  });

  var swiper_gallery_fotos = new Swiper(".swiper_gallery-fotos", {
    loop: true,
    spaceBetween: 10,
    autoplay: {
        delay: 4000,
        disableOnInteraction: false,
    },
    breakpoints: {
        425:{
          slidesPerView: 1,
          spaceBetween: 30,
        },
        503: {
          slidesPerView: 2,
          spaceBetween: 30,
        },
        992: {
          centeredSlides: true,
          slidesPerView: 3,
          spaceBetween: 30,
        },
        1299: {
          centeredSlides: true,
          slidesPerView: 3,
          spaceBetween: 30,
        },
    },
    navigation: {
        nextEl: ".gallery-fotos-button-next",
        prevEl: ".gallery-fotos-button-prev",
      },
  });


  var swiper_gallery_plantas = new Swiper(".swiper_gallery-plantas", {
    loop: true,
    spaceBetween: 10,
    autoplay: {
        delay: 4000,
        disableOnInteraction: false,
    },
    breakpoints: {
        425:{
          slidesPerView: 1,
          spaceBetween: 30,
        },
        503: {
          slidesPerView: 2,
          spaceBetween: 30,
        },
        992: {
          centeredSlides: true,
          slidesPerView: 3,
          spaceBetween: 30,
        },
        1299: {
          centeredSlides: true,
          slidesPerView: 3,
          spaceBetween: 30,
        },
    },
    navigation: {
        nextEl: ".gallery-plantas-button-next",
        prevEl: ".gallery-plantas-button-prev",
      },
  });


  var galery_single = new Swiper(".galery_single", {
    loop: true,
    spaceBetween: 10,
    slidesPerView: 4,
    freeMode: true,
    watchSlidesProgress: true,
  });

  var galery_single2 = new Swiper(".galery_single2", {
    loop: true,
    spaceBetween: 10,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    thumbs: {
      swiper: galery_single,
    },
  });